import script from "./CameraCapture.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraCapture.vue?vue&type=script&setup=true&lang=js"

import "./CameraCapture.vue?vue&type=style&index=0&id=0de8c3cc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de8c3cc"]])

export default __exports__